<div [ngStyle]="{'width': width?width:'100%'}"
     class="layout vertical center middle">
    <ng-container>
        <!--EQUAL FILTER-->
        <div [hidden]="value.mode=='between'" style="width: 100%;">
            <app-form-field #equal
                            [type]="type"
                            [label]="equalLabel"
                            [settings]="settings"
                            [value]="valueForInput ? valueForInput.equal : null"
                            (modelChange)="onEqualFilterChange($event)"
                            mode="filter">
            </app-form-field>
        </div>
        <!--BETWEEN FILTER-->
        <div [hidden]="value.mode=='equal'" style="width: 100%;">
            <div style="width: 100%;">
                <app-form-field #from 
                                [type]="type"
                                [label]="fromLabel"
                                [settings]="settings"
                                [value]="valueForInput ? valueForInput.from : null"
                                (modelChange)="onFromFilterChange($event)"
                                mode="filter">
                </app-form-field>
            </div>
            <div style="width: 100%;">
                <app-form-field #to
                                [type]="type"
                                [label]="toLabel"
                                [settings]="settings"
                                [value]="valueForInput ? valueForInput.to : null"
                                (modelChange)="onToFilterChange($event)"
                                mode="filter">
                </app-form-field>
            </div>
        </div>
    </ng-container>
    <!--
    EQUAL|BETWEEN SWITCH
    -->
    <div *ngIf="['INTEGER', 'NUMBER', 'DATE', 'TIME','DATETIME'].includes(type+'')"
        style="z-index:999; text-align:right; width: 100%;">
        <span (click)="toggleMode()" style="cursor:pointer; font-size: x-small; color:gray; padding: 0 2px;">
            <span [ngStyle]="{'color': value.mode=='equal'?'black':'gray'}">EQUAL</span> | <span [ngStyle]="{'color': value.mode=='between'?'black':'gray'}">BETWEEN</span>
        </span>
    </div>
</div>
